import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomItemInfoBoxComponent } from './custom-item-info-box.component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [CustomItemInfoBoxComponent],
  exports: [CustomItemInfoBoxComponent],
    imports: [
        CommonModule,
        I18nModule,
        MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ItemInfoBoxComponent: {
                    component: CustomItemInfoBoxComponent,
                },
            },
        } as CmsConfig),
        RouterModule,
    ]
})
export class CustomItemInfoBoxModule { }
